<template>
  <section id="zasady" class="rules text-center">
    <div class="row">
      <div class="column large-offset-1 large-10">
        <h2>Zasady i nagrody</h2>
        <p>
          Kup Królewskie Jasne Pełne w opakowaniu promocyjnym i zajrzyj pod kapsel lub zawleczkę. <br />
          <strong>Sprzedaż promocyjna trwa od 30.12.2025 r. do 05.09.2026 r.</strong> <br />
          Loteria promocyjna prowadzona jest na terenie województw:mazowieckiego i lubelskiego.
        </p>
      </div>
    </div>
    <div class="row align-middle">
      <div class="column small-12 medium-6 small-order-2 medium-order-1 medium-text-left">
        <p>
          Znajdź pod kapslem zakupionego piwa <b>“WYGRAŁEŚ 4 KRÓLEWSKIE 2026”</b> / <b>“WYGRAŁEŚ 1 KRÓLEWSKIE 2026”</b> lub <b>“4xKROL 2026”</b> /
          <b>“1xKROL 2026”</b> pod zawleczką i&nbsp;odbierz nagrodę.
        </p>
        <p>
          Wymień kapsel lub zawleczkę na piwo Królewskie Jasne Pełne w wybranym sklepie <strong>od&nbsp;30.12.2025&nbsp;r. do&nbsp;05.09.2026&nbsp;r.</strong>
        </p>
        <a href="/regulamin2026.pdf" target="_blank" class="link--regulation">Szczegóły w regulaminie</a>
      </div>
      <div class="column small-12 medium-6 small-order-1 medium-order-2">
        <img src="/images/2026/win-with-kapsel.png" alt="Wygraj 4-pak lub piwo" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Rules'
}
</script>

<style lang="scss" scoped>
.rules {
  margin: 2.5rem 0;

  @include media-up(md) {
    margin: 4.5rem 0;
  }

  h2 {
    margin-bottom: 1rem;
  }

  .row {
    @include media-up(md) {
      margin-bottom: 1.5rem;
    }
    @include media-up(lg) {
      margin-bottom: 3.5rem;
    }
  }

  p {
    font-size: 1em;
    line-height: 1.5;
  }

  .link--regulation {
    color: #d7b46a;
    font-weight: 900;
  }
}
</style>
